const Features = ({ content }) => {
  // Default features as fallback if content is not provided
  const features = content || [
    {
      id: "feature-1",
      icon: '🎨',
      title: 'Fully Customizable',
      description: 'Personalize your page with custom colors, fonts, and layouts to match your brand.',
    },
    {
      id: "feature-2",
      icon: '📱',
      title: 'Mobile Optimized',
      description: 'Your page looks perfect on any device, ensuring the best experience for your audience.',
    },
    {
      id: "feature-3",
      icon: '📊',
      title: 'Analytics Dashboard',
      description: 'Track clicks, views, and engagement to understand your audience better.',
    },
    {
      id: "feature-4",
      icon: '🔗',
      title: 'Unlimited Links',
      description: 'Add as many links as you need. Social media, websites, stores - anything goes.',
    },
    {
      id: "feature-5",
      icon: '⚡',
      title: 'Lightning Fast',
      description: 'Pages load instantly with our optimized infrastructure and global CDN.',
    },
    {
      id: "feature-6",
      icon: '🔒',
      title: 'Secure & Reliable',
      description: 'SSL encryption and 99.9% uptime guarantee your links are always accessible.',
    },
  ];

  return (
    <section id="features" className="py-20 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Everything you need to{' '}
            <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
              stand out
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Powerful features to help you create the perfect link-in-bio page for your audience.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={feature.id || index}
              className="bg-white p-8 rounded-xl shadow-sm hover:shadow-xl transition-shadow duration-300 animate-slide-up"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="text-4xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features; 